import { useMemo, useState } from "react";
import getSymbolFromCurrency from "currency-symbol-map";
import Drawer from "../../../../parts/drawer";
import DetailsComponent from "./DetailsComponent";
import ChangePlan from "./ChangePlan";

const SubscriberDetails = ({
  subscriptions,
  customer,
  toggleDrawer,
  type = "membership",
  handleCancel = () => {},
  subscriberInvoices = {},
  price,
  upcomingInvoice,
}) => {
  const [step, setStep] = useState("details");
  const [selectedPlan, setSelectedPlan] = useState("");
  const sub = useMemo(() => {
    let sub;

    if (customer && subscriptions?.length) {
      sub = subscriptions.find(
        (subscription) => subscription.customer == customer
      );
    }

    return sub;
  }, [subscriptions, customer]);

  const planData = useMemo(() => {
    if (!subscriberInvoices.prices?.length) return null;

    const price = subscriberInvoices.prices.find((pr) => {
      return pr.id === sub.plan.id;
    });
    const currency = getSymbolFromCurrency(price.currency);
    const selectPlans = subscriberInvoices.prices
      .filter((plan) => {
        return (
          plan.id !== price.id &&
          plan.currency === price.currency &&
          plan.active
        );
      })
      .map((plan) => {
        return { ...plan, value: plan.id, label: plan.nickname };
      });
    return { price, currency, selectPlans };
  }, [subscriberInvoices.prices, sub]);

  const close = (e) => {
    setInitState();
    toggleDrawer(e);
  };

  const setInitState = () => {
    setStep("details");
    setSelectedPlan("");
  };

  const renderDrawerContent = () => {
    if (step === "change") {
      return (
        <ChangePlan
          toggleDrawer={close}
          planData={planData}
          sub={sub}
          selectedPlan={selectedPlan}
          setSelectedPlan={setSelectedPlan}
          price={price}
          upcomingInvoice={upcomingInvoice}
          setInitState={setInitState}
        />
      );
    } else {
      return (
        <DetailsComponent
          sub={sub}
          toggleDrawer={close}
          type={type}
          handleCancel={handleCancel}
          subscriberInvoices={subscriberInvoices}
          setStep={setStep}
        />
      );
    }
  };

  return (
    <Drawer show={!!customer} close={close} header={false}>
      {renderDrawerContent()}
    </Drawer>
  );
};

export default SubscriberDetails;
